<div id="main">
    <!-- TOOLBAR: Above -->
    <ng-container *ngIf="layoutConfig.layout.toolbar.position === 'above' && !fullscreenService.isFullScreenActive">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <!-- / TOOLBAR: Above -->

    <div id="container-1" class="container">

        <!-- NAVBAR: Left -->
        <ng-container *ngIf="layoutConfig.layout.navbar.position === 'left' && !fullscreenService.isFullScreenActive">
            <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Left -->

        <div id="container-2" class="container">

            <!-- TOOLBAR: Below fixed -->
            <ng-container *ngIf="layoutConfig.layout.toolbar.position === 'below-fixed'">
                <ng-container *ngTemplateOutlet="toolbar"></ng-container>
            </ng-container>
            <!-- / TOOLBAR: Below fixed -->

            <div id="container-3" class="container" fusePerfectScrollbar
                 [fusePerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

                <!-- TOOLBAR: Below static -->
                <ng-container
                    *ngIf="layoutConfig.layout.toolbar.position === 'below-static' && !fullscreenService.isFullScreenActive">
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                </ng-container>
                <!-- / TOOLBAR: Below static -->

                <!-- CONTENT -->
                <content id="maincontent" tabindex="-1"></content>
                <!-- / CONTENT -->

                <!-- FOOTER: Below static -->
                <ng-container *ngIf="layoutConfig.layout.footer.position === 'below-static'">
                    <ng-container *ngTemplateOutlet="footer"></ng-container>
                </ng-container>
                <!-- / FOOTER: Below static -->

            </div>

            <!-- FOOTER: Below fixed -->
            <ng-container *ngIf="layoutConfig.layout.footer.position === 'below-fixed'">
                <ng-container *ngTemplateOutlet="footer"></ng-container>
            </ng-container>
            <!-- / FOOTER: Below fixed -->

        </div>

        <!-- NAVBAR: Right -->
        <ng-container *ngIf="layoutConfig.layout.navbar.position === 'right'">
            <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Right -->

    </div>

    <!-- FOOTER: Above -->
    <ng-container *ngIf="layoutConfig.layout.footer.position === 'above'">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-container>
    <!-- FOOTER: Above -->

</div>

<!-- QUICK PANEL -->
<fuse-sidebar name="quickPanel" position="right" class="quick-panel" *ngIf="!layoutConfig.layout.quickPanel?.hidden">
    <ng-container *ngIf="!layoutConfig.layout.quickPanel?.hidden">
        <ng-container *ngComponentOutlet="quickPanelComponent"></ng-container>
    </ng-container>
</fuse-sidebar>
<!-- / QUICK PANEL -->

<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- @ PARTIALS -->
<!-- ----------------------------------------------------------------------------------------------------- -->

<!-- TOOLBAR -->
<ng-template #toolbar>
    <toolbar *ngIf="!layoutConfig.layout.toolbar.hidden"
             [ngClass]="[layoutConfig.layout.toolbar.position, layoutConfig.layout.toolbar.background]"></toolbar>
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
    <footer *ngIf="!layoutConfig.layout.footer.hidden"
            [ngClass]="[layoutConfig.layout.footer.position, layoutConfig.layout.footer.background]"></footer>
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
    <fuse-sidebar name="navbar" class="navbar-fuse-sidebar"
                  [folded]="layoutConfig.layout.navbar.folded"
                  lockedOpen="gt-md"
                  *ngIf="!layoutConfig.layout.navbar.hidden">
        <navbar [variant]="layoutConfig.layout.navbar.variant"
                class="left-navbar" [ngClass]="layoutConfig.layout.navbar.background"></navbar>
    </fuse-sidebar>

</ng-template>
<!-- / LEFT NAVBAR -->

<!-- RIGHT NAVBAR -->
<ng-template #rightNavbar>
    <fuse-sidebar name="navbar" position="right" class="navbar-fuse-sidebar"
                  [folded]="layoutConfig.layout.navbar.folded"
                  lockedOpen="gt-md"
                  *ngIf="!layoutConfig.layout.navbar.hidden">
        <navbar [variant]="layoutConfig.layout.navbar.variant"
                class="right-navbar" [ngClass]="layoutConfig.layout.navbar.background"></navbar>
    </fuse-sidebar>
</ng-template>
<!-- / RIGHT NAVBAR -->
